/// <amd-module name="Search/Wiki/Components/Notification" />
import * as Resources from "Search/Shared/Resources";
import { IAggregatedState } from "Search/Wiki/Flux/StoresHub";
import { INotificationProps } from "Search/Shared/Components/NotificationArea";
import { ActionCreator } from "Search/Wiki/Flux/ActionCreator";
import { MessageBarSeverity } from "VSSUI/MessageBar";
import { ObservableValue } from "VSS/Core/Observable";
import { OrgSearchUrlLoadState } from "Search/Shared/Base/Stores/OrganizationInfoStore";

export function handlePivotNotification(
    pageNotification: ObservableValue<INotificationProps>,
    getAggregatedState: () => IAggregatedState,
    actionCreator: ActionCreator) {
    const { organizationInfoState } = getAggregatedState();
    const { errorNotificationBannerDismissed, publishNotificationBanner } = actionCreator;

    const isOrgSearchUrlLoadFailed = organizationInfoState.orgSearchUrlLoadState === OrgSearchUrlLoadState.OrgSearchUrlLoadFailed;

    if (isOrgSearchUrlLoadFailed) {
        // Handle indexing scenarios
        pageNotification.value = {
            visible: true,
            isFormatted: false,
            severity: MessageBarSeverity.Error,
            message: Resources.FailedLoadingOrgURLMessage,
            onDismiss: errorNotificationBannerDismissed
        }

        publishNotificationBanner(OrgSearchUrlLoadState[organizationInfoState.orgSearchUrlLoadState]);
    } else {
        // dispose notification if none of indexing is in progress, or partial results are obtained.
        pageNotification.value = {
            ...pageNotification.value,
            visible: false
        }
    }
}